import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';

@Component({
  selector: 'app-admin-history-report-dialog',
  templateUrl: './history-report-dialog.component.html',
  styleUrls: ['./history-report-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatButtonModule,
    MatInputModule,
  ],
  providers: [provideLuxonDateAdapter()],
})
export class HistoryReportDialogComponent {
  dialogRef = inject<MatDialogRef<HistoryReportDialogComponent>>(MatDialogRef);
  private _snackBar = inject(MatSnackBar);
  data = inject(MAT_DIALOG_DATA);

  type = 'model';
  headline: string;
  content: string;
  confirm: string;
  placeholder: string;
  update = false;
  required = Validators.required;
  startDate = new FormControl(
    new Date(DateTime.now().minus({ days: 30 }).toLocaleString('MM/DD/YYYY'))
  );
  endDate = new FormControl(new Date());

  cancel() {
    this.dialogRef.close({ result: 'cancel' });
  }

  download() {
    if (
      this.startDate.status !== 'INVALID' &&
      this.endDate.status !== 'INVALID'
    ) {
      this.dialogRef.close({
        result: 'download',
        data: {
          startDate: this.startDate.value,
          endDate: this.endDate.value,
        },
      });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    } else if (
      this.startDate.status === 'INVALID' &&
      this.endDate.status === 'INVALID'
    ) {
      this.openSnackBar('Please select start and end dates');
    } else if (
      this.startDate.status === 'VALID' &&
      this.endDate.status === 'INVALID'
    ) {
      this.openSnackBar('Please select an end date');
    } else if (
      this.startDate.status === 'INVALID' &&
      this.endDate.status === 'VALID'
    ) {
      this.openSnackBar('Please select an start date');
    }
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: 2000,
    });
  }
}
